<div class="card m-l-15 m-b-15 base-shadow-list b-0">
    <div class="card-body pb-0 m-b-15">
        <div class="selectParent row p-b-20">
            <div class="col-3 pr-0 c-default">
                <div class="caption" id="apprasee">
                    Appraisee
                </div>
                <div class="font-weight-bold lh-2">
                    {{ appraiseeProcessDetailDto?.appraisee?.isActive ? appraiseeProcessDetailDto?.appraisee?.name : appraiseeProcessDetailDto?.appraisee?.gpid }}
                </div>
            </div>
            <div class="col-2 c-default">
                <div class="caption">
                    Deadline:
                </div>
                <div (click)="$event.stopPropagation()" class="calendar">
                    <input type="text" 
                    #endDate="bsDatepicker"
                    [formControl]="endDateControl"
                    [minDate]="currentDate"
                     bsDatepicker
                     [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY' }" />
                    <i (click)="endDate.toggle()" class="fa fa-calendar"></i>
                </div>
            </div>
            <div class="col-3 pl-0 c-default">
                <div class="caption correct-process">
                    Stage of the process:
                </div>
                <div (click)="$event.stopPropagation()">
                    <ngx-select 
                    [items]="stageItems"
                    [formControl]="stageControl"
                    [defaultValue]="[appraiseeProcessDetailDto.stage]">
                </ngx-select>
                </div>
            </div>
            <div class="col-2 c-default">
                <div class="float-left">
                    <div class="caption">
                        Passing:
                    </div>
                    <div class="passing">
                        <span class="not-passing-number">{{ appraiseeProcessDetailDto.completedProcessParticipationAmmount }}</span> of <span>{{appraiseeProcessDetailDto.processParticipationAmmount}}</span>
                    </div>
                </div>
            </div>
            <div class="col-2 c-default">
                <div (click)="$event.stopPropagation()">
                  <span *ngIf="stageControl.touched || endDateControl.touched" class="save" (click)="onSaveClicked(approveModal)">Save</span>
                    <span class="collapsed" (click)="isCollapsed = !isCollapsed">
                        <i class="fa"
                           [class.fa-caret-down]="isCollapsed"
                           [class.fa-caret-up]="!isCollapsed"></i>
                    </span>
                </div>
            </div>
        </div>
        <div *ngIf="!isCollapsed" class="row ml-0 mr-0 details-passing">
            <div *ngIf="respondentsInProcess.length" class="col-12 p-t-10 pl-0 pr-0">
                <div class="d-flex justify-content-between">
                        <label class="caption">In Process</label>
                        <div>
                            <button *ngIf="isRespondentsInProcess()" (click)="unSelectRespondentsInProcess()" class="select-all"> Unselect all </button>
                            <button (click)="selectRespondentsInProcess()" class="select-all">Select all</button>
                        </div>
                </div>
                <div class="d-flex respondent-field">
                    <div class="respondent-name" *ngFor="let respondent of respondentsInProcess">
                            <input
                            type="checkbox"
                            [checked]="respondent.isSelected"
                            (click)="toogleRespondent(respondent)"
                            [id]="getId(appraiseeProcessDetailDto, respondent)">
                            <label [for]="getId(appraiseeProcessDetailDto, respondent)" >{{respondent.isActive ? respondent.name : respondent.gpid}}</label>
                    </div>
                </div>
            </div>
            <div *ngIf="respondentsCompleted.length" class="col-12 p-t-10 pl-0 pr-0">
                <label class="caption">Completed</label>
                <div class="d-flex respondent-field">
                    <div class="respondent-name completed" *ngFor="let respondent of respondentsCompleted; last as isLast">
                    {{respondent.isActive ? respondent.name : respondent.gpid}}<ng-container *ngIf="!isLast">; </ng-container>
                    </div>
                </div>
            </div>
            <div *ngIf="respondentsCanceled.length" class="col-12 p-t-10 pl-0 pr-0">
                <label class="caption">Canceled</label> 
                <div class="d-flex respondent-field">
                    <div class="respondent-name" *ngFor="let respondent of respondentsCanceled">
                        <input
                        type="checkbox"
                        [checked]="respondent.isSelected"
                        (click)="toogleRespondent(respondent)"
                        [id]="getId(appraiseeProcessDetailDto, respondent)">
                        <label [for]="getId(appraiseeProcessDetailDto, respondent)" >{{respondent.isActive ? respondent.name : respondent.gpid}}</label>
                    </div>
                </div>
            </div>
            <div *ngIf="respondentsSkipped.length" class="col-12 p-t-10 pl-0 pr-0">
                <label class="caption">Skipped</label>
                <div class="d-flex respondent-field">
                    <div class="respondent-name" *ngFor="let respondent of respondentsSkipped">
                        <input
                        type="checkbox"
                        [checked]="respondent.isSelected"
                        (click)="toogleRespondent(respondent)"
                        [id]="getId(appraiseeProcessDetailDto, respondent)">
                        <label [for]="getId(appraiseeProcessDetailDto, respondent)" >{{respondent.isActive ? respondent.name : respondent.gpid}}</label>
                    </div>
                </div>
            </div>
            <div class="m-t-10" *ngIf="!isCancelledOrCompleted()">
                <span (click)="openAddRespondentModal()"  class="add-btn"></span>
            </div>
        </div>
    </div>
</div>
<ng-template #approveModal>
        <div class="modal-body">
            <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="d-flex justify-content-center flex-column" style="min-height: 90px;">
                <div>
                    Do you want to send notifications?
                </div>
            </div>
            <div class="btn-modal">
                <span (click)="updateAppraiseeProcessDetail(true)">Yes</span>
                <span (click)="updateAppraiseeProcessDetail(false)">No</span>
            </div>
        </div>
</ng-template>